import { useNavigate } from 'react-router-dom';
import { Check, ArrowRight } from 'lucide-react';
import Nav from '../../components/marketing/Nav';
import Footer from '../../components/marketing/Footer';
import { Button } from '../../components/ui/button';
import { SUBPAGES } from '../../lib/constants';

export default function SubPage({ slug }) {
  const nav = useNavigate();
  const p = SUBPAGES[slug];
  if (!p) return null;
  return (
    <div className="min-h-screen bg-[#090A0F]">
      <Nav />
      <section className="max-w-4xl mx-auto px-5 pt-20 pb-12 text-center relative grain">
        <div className="absolute inset-0 brand-glow pointer-events-none" />
        <div className="relative">
          <div className="text-5xl mb-5">{p.emoji}</div>
          <h1 className="font-heading text-4xl sm:text-5xl font-extrabold tracking-tight">{p.title}</h1>
          <p className="text-slate-400 mt-5 text-lg max-w-2xl mx-auto">{p.subtitle}</p>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-5 pb-12">
        <div className="rounded-2xl border border-white/10 bg-[#12141D] p-8 space-y-4">
          {p.points.map((pt) => (
            <div key={pt} className="flex items-start gap-3">
              <span className="grid place-items-center w-6 h-6 rounded-full bg-gradient-to-br from-[#FF4D00] to-[#8B5CF6] shrink-0 mt-0.5">
                <Check className="w-3.5 h-3.5 text-white" />
              </span>
              <span className="text-slate-200">{pt}</span>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-5 pb-24 text-center">
        <Button data-testid="subpage-cta" onClick={() => nav('/signup')} size="lg" className="rounded-full h-12 px-8 font-semibold">
          Try it free <ArrowRight className="w-4 h-4 ml-1" />
        </Button>
      </section>
      <Footer />
    </div>
  );
}
